import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    np: {
        logoText: 'डकुमेण्ट लाईब्रेरी',
        nav: {
          contact: 'सम्पर्क'  
        },
        banner: {
            documentsIn: 'कागजातहरू',
            laws: 'कानुन/विनियम। नियम/नियमावली/निर्देशिका',
            research: 'अनुसन्धान प्रतिवेदन',
            surveys: 'सर्वेक्षणहरु',
            gov: 'सरकारकाे वार्षिक प्रगति प्रतिवेदन',
            viewDetail: 'विवरण हेर्नुहोस्',
            hideDetail: 'विवरण लुकाउनुहोस्',
            
        },
        filters: {
            filterToggle: 'कागजात फिल्टर',
            filterTitle: 'कागजात फिल्टर गर्नुहाेस्',
            categories: 'वर्ग',
            subCategories: 'उपवर्ग',
            publishedDates: 'प्रकाशित मिति',
            documentTitle: 'कागजातको शीर्षक',
            documentType: 'कागजातको प्रकार',
            documentSource: 'कागजातकाे  स्राेत',
            publishedDatePlaceholder: 'Select publication date',
            filterButton: 'फिल्टर गर्नुहाेस्',
            clear: 'रिसेट गर्नुहाेस्'
        },
        dataListHeader: {
            title: 'कागजातहरू',
            searchResults: 'Search results for'
        },
        dataBlock: {
            viewDetails: 'थप जानकारी',
            sources: 'स्रोतहरू',
            uploadedOn: 'मा अपलाेड गरिएकाे '
        },
        sorting: {
            sortBy: 'क्रमबद्ध गर्नुहोस्',
            recentlyAdded: 'हालसालै थपिएकाे',
            oldestFirst: 'पुरानाे पहिला',
            selectOption: 'विकल्प चयन गर्नुहोस्'
        },
        search: {
            search: 'खाेज्नुहाेस्',
            placeholder: 'शीर्षकबाट कागजात खाेज्नुहाेस्'
        },
        munSelect: {
            allMun: 'सबै स्थानिय सरकारहरु'
        },
        detail: {
            goBack: 'कागजातमा फिर्ता जानुहोस ',
            downloadDocuments: 'कागजात डाउनलाेड गर्नुहाेस्',
            downloadAll: 'सबै डाउनलाेड गर्नुहाेस्',
            downloadFiles: 'फाइल डाउनलाेड गर्नुहाेस्',
            relatedDocuments: 'सम्बन्धित कागजातहरु',
            timestamp: 'कागजातमा फिर्ता'
        },
        contact: {
            error: {
                name: 'कृपया आफ्नो नाम प्रविष्ट गर्नुहोस्',
                emailRequired: 'कृपया तपाईंको इमेल प्रविष्ट गर्नुहोस्',
                message: 'कृपया सन्देश प्रविष्ट गर्नुहोस्',
                emailInvalid: 'मान्य इमेल होइन'
            } ,
            labels: {
                name: 'नाम',
                email: 'इमेल',
                message: 'सन्देश'
            },
            contact: 'सम्पर्क',
            sendMessage: 'सन्देश पठाउनुहोस्',
            messageSent: 'सन्देश पठाइयो',
            errorOccured: 'त्रुटि भयो',
            submitMessage: 'पठाउनुहोस्',
            success: 'सफल भयो !!',
            successMessage: 'तपाईंको सन्देश सफलतापूर्वक डेलिभर गरिएको छ'
        },
        noData: {
            showFor: 'सबै स्थानिय सरकारहरुकालागी देखाउनुहोस',
            reset: 'रिसेट गर्नुहाेस्',
            noDocument: 'कुनै कागजात भेटिएन',
            noDetail: 'जानकारी उपलब्ध भएन'
        },
        networkError: {
            somethingWrong: 'केहि समस्या भेटियो  !!',
            errorMessage: 'हामीले पृष्ठ लोड गर्दा समस्या भइरहेको छ। कृपया तपाइँको जडान जाँच्नुहोस् र फेरि प्रयास गर्नुहोस्'
        }
    },
    en: {
        logoText: 'Document Library',
        nav: {
          contact: 'Contact'  
        },
        banner: {
            documentsIn: 'Documents in',
            laws: 'Laws \ ByLaws \ Rules \ Regulations \ Directories',
            research: 'Research Projects',
            surveys: 'Surveys',
            gov: 'Government Annual Progress Report',
            viewDetail: 'View Detail',
            hideDetail: 'Hide Detail'
        },
        filters: {
            filterToggle: 'Filter Documents',            
            filterTitle: 'Filter Documents by',
            categories: 'Categories',
            subCategories: 'Subcategories',            
            documentType: 'Document Type',
            documentSource: 'Document Source',
            publishedDates: 'Date of Publication',
            documentTitle: 'Document Title',
            publishedDatePlaceholder: 'Select publication date',
            filterButton: 'Filter Documents',
            clear: 'Clear'
        },
        dataListHeader: {
            title: 'Documents',
            searchResults: 'Search results for'
        },
        dataBlock: {
            viewDetails: 'View Details',
            sources: 'Sources',
            uploadedOn: 'Uploaded on'
        },
        sorting: {
            sortBy: 'Sort by',
            recentlyAdded: 'Recently Added',
            oldestFirst: 'Oldest First',
            selectOption: 'Select option'
        },
        search: {
            search: 'Search',
            placeholder: 'Search for documents by title'
        },
        munSelect: {
            allMun: 'All Municipalities'
        },
        detail: {
            goBack: 'Back to Documents',
            downloadDocuments: 'Download Documents',
            downloadAll: 'Download all data',
            downloadFiles: 'Download Files',
            relatedDocuments: 'Related Documents',
            timestamp: 'Uploaded on'
        },
        contact: {
            error: {
                name: 'Please enter your name',
                emailRequired: 'Please enter your email',
                message: 'Please enter your message',
                emailInvalid: 'is not valid email'
            } ,
            labels: {
                name: 'Name',
                email: 'Email',
                message: 'Message'
            },
            contact: 'Contact',
            sendMessage: 'Send message',
            messageSent: 'Message sent',
            errorOccured: 'Error occured',
            submitMessage: 'Submit message',
            success: 'Success !!',
            successMessage: 'Your message has been delivered successfully.'
        },
        noData: {
            showFor: 'Show for all municipalities',
            reset: 'Reset Filters',
            noDocument: 'No document available',
            noDetail: 'No detail found'
        },
        networkError: {
            somethingWrong: 'Something went wrong !!',
            errorMessage: 'We are having trouble loading the page. Please check your connection and try again'
        }
    },
})

export default strings;


// WEBPACK FOOTER //
// ./src/config/language.js